export default () => {
    const videos = document.querySelectorAll('.sus-video video');

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                const video = entry.target;
                if (entry.isIntersecting) {
                    video.play().catch((error) => {
                        console.warn('Auto-play was prevented:', error);
                    });
                } else {
                    video.pause();
                }
            });
        },
        {
            rootMargin: '0px 0px',
        }
    );

    videos.forEach((video) => {
        observer.observe(video);
    });
};
